import {Component, Input} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BaseComponent} from "../../../../base/components/base.component";
import {EventBusService} from "../../../../base/services/eventbus/event-bus.service";
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../base/services/subscription-container.service";
import {VendorService} from "../../services/vendor.service";
import {Observable, of} from "rxjs";
import {IPage} from "../../../../base/models/pagination.model";
import {IVendor} from "../../models/inventory/vendor.model";
import {LeaderboardService} from "../../../common/modules/accounting/leaderboard/services/leaderboard.service";
import {IRedeem, IRedeemReq} from "../../../common/modules/accounting/leaderboard/models/redeem.model";
import {NotifierService} from "../../../../base/services/notifier/notifier.service";
import {EventKey} from "../../../../registry/event.key";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'app-redeem',
    templateUrl: './redeem.component.html',
    styleUrls: ['./redeem.component.scss']
})
export class RedeemComponent extends BaseComponent {
    @Input() availablePoints: number = 0
    redemption: IRedeem | null = null

    vendors: IVendor[] = []

    redeemForm = new FormGroup({
        vendor: new FormControl('', Validators.min(1)),
        points: new FormControl('', [
            Validators.required,
            Validators.min(100),
            Validators.max(1000)
        ])
    })

    //BarcodeFormat.QR_CODE
    allowedFormats = [11, 7, 4, 5];
    scannedCode: { name: string, uuid: string, p: string } | null = null

    constructor(
        eventBus: EventBusService,
        router: Router,
        subContainer: SubscriptionContainerService,
        private vendorService: VendorService,
        private leaderboardService: LeaderboardService,
        private notifier: NotifierService
    ) {
        super(eventBus, router, subContainer)
    }

    protected componentName(): string {
        return "RedeemComponent";
    }

    ngOnInit(): void {
    }

    redeem() {
        if (this.scannedCode == null) return
        let key = this.componentKey(EventKey.LEADERBOARDS.REDEEM_SUCCESS())
        this.leaderboardService.redeem(key, this.mapToRedeemReq(this.redeemForm))
        this.subscribe(key, null, (value, meta) => {
            this.redemption = meta.data
        })
        this.subscribe(this.getErrorKey(key), null, (value, meta) => {
            let error: HttpErrorResponse = meta.data
            // console.log(error)
            this.notifier.warning('Failed!', error.error.message)
        })
    }

    searchVendors() {
        let vendor = this.redeemForm.controls['vendor'].value
        const key = this.vendorService.searchVendors(false, vendor ? vendor : "")
        this.subscribe(key, null, (value, meta) => {
            let vendorPage: IPage<IVendor> = meta.data
            this.vendors = vendorPage.content
        })
    }

    getVendors(): Observable<IVendor[]> {
        return of(this.vendors)
    }

    private mapToRedeemReq(redeemForm: FormGroup): IRedeemReq {
        return {
            vendor_uuid: this.scannedCode?.uuid + '',
            points: redeemForm.controls['points'].value
        }
    }


    onScanSuccess(event: any) {
        try {
            this.scannedCode = JSON.parse(event)
        } catch (e) {
            this.notifier.warning('Invalid QR', String(e))
        }
    }

    onScanFailure(event: any) {
        console.log(event)
    }
}
